import axios from 'axios'
import AxiosWrapper from './utils/axiosWrapper'

export { default as requestErrorHandler } from './utils/requestErrorHandler'

const service = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api_old',
  withCredentials: true,
  timeout: 50000,
})

// 获取指定名称的cookie
function getCookie(name: string): string {
  const strcookie = document.cookie // 获取cookie字符串
  const arrcookie = strcookie.split('; ') // 分割
  // 遍历匹配
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < arrcookie.length; i++) {
    const arr = arrcookie[i].split('=')
    if (arr[0] === name) {
      return arr[1]
    }
  }
  return ''
}

// Add a request interceptor
service.interceptors.request.use(
  config => {
    // eslint-disable-next-line no-param-reassign
    config.headers['Session-ID'] = getCookie('Session-ID')
    return config
  },
  error => Promise.reject(error)
)

// Add a response interceptor
service.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export default new AxiosWrapper(service)
